module.exports = "/_next/static/images/51be344cdde5fef6260239f0ec1279ac-man-looking-at-phone@lg-2x.jpg.webp";